import { render, staticRenderFns } from "./AdminSubCategoryInterna.vue?vue&type=template&id=6896e020&scoped=true&"
import script from "./AdminSubCategoryInterna.vue?vue&type=script&lang=js&"
export * from "./AdminSubCategoryInterna.vue?vue&type=script&lang=js&"
import style0 from "./AdminSubCategoryInterna.vue?vue&type=style&index=0&id=6896e020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896e020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCheckbox,VFileInput,VSelect,VSnackbar})
